theme.GraphQL = {

    config:  {
        storefront_token: '6e746facec25c62fb143dde0d353b514',
        request_url: 'https://smile-club-store.myshopify.com/api/2022-10/graphql.json'
    },

    sendRequest: function(request, request_group, output_container) {

        if(this.config[request_group] == null) {
            this.config[request_group] = 1;
        } else {
            this.config[request_group]++;
        }

        let return_response = null;

        let settings = {
            'crossDomain': true,
            'url': this.config.request_url,
            'method': 'POST',
            'headers': {
                'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
                'Content-Type': 'application/graphql',
            },
            'data': request,
            'success': function(response) {
                theme.GraphQL.config[request_group]--;
                return_response = response;
            },
            'error': function(xhr, errDesc) {
                theme.GraphQL.config[request_group]--;
                console.log(errDesc);
            }
        };
        $.ajax(settings)
            .done(function() {
                if(request_group === "addons") {
                    theme.ProductAddons.buildOutput(return_response);
                }

                if(request_group === "available-in") {
                    theme.AlsoAvailableIn.buildOutput(return_response);
                }
                theme.GraphQL.cleanUp(request_group);
            });
    },

    cleanUp: function(request_group) {
        if(theme.GraphQL.config[request_group] < 1) {
            $('body').trigger(request_group+":loaded");
            delete this.config[request_group];
        }
    }
};

theme.Helpers = {
    addItemToCartFromID: function(id, properties) {
        let item_data = [];

        item_data.push({quantity: 1, id: id, properties: properties});

        $.post('/cart/add.js', {
            items: item_data,
        }, function() {
            $('body').trigger('added.ajaxProduct');
        });
    },

    removeItemsFromCart (keys) {
        let qty = 0,
            items_data = { updates: {} };

        for(let i=0;i<keys.length;i++) {
            items_data.updates[keys[i]] = qty;
        }

        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: items_data,
            dataType: 'json',
            success: function() {
                $('body').trigger('added.ajaxProduct');
            }
        });
    },

    removeSingleItemFromCart: function(key) {
        let items_data = { updates: {} },
            qty = 0;
        items_data.updates[key] = qty;

        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: items_data,
            dataType: 'json',
            success: function() {
                $('body').trigger('added.ajaxProduct');
            }
        });
    },

    retreiveID: function(input) {
        return (window.atob(input)).split("/").pop();
    },

    formatMoney: function(cents, format) {
        let money_format = "${{amount}}";

        if (typeof cents == 'string') { cents = cents.replace('.',''); }
        let value = '';
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let formatString = (format || money_format);

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal   = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) { return 0; }

            number = (number/100.0).toFixed(precision);

            let parts   = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch(formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    },

    fetchCart: async function() {
        try {
          const res = await fetch('/cart.js');
          const data = await res.json();
          if (res.ok) return data;
        } catch (error) {
          console.log(error);
          return null
        }
    }

};

theme.AlsoAvailableIn = (function() {
    let $container;

    function init(container) {
        $container = $(container);
        this.$output_container = $container.find('.also-available-container');
        let search_term = $container.data('group-tag');
        let search_query = `{
          products(first: 10, query: "${search_term}") {
            edges {
              node {
                title
                handle
                onlineStoreUrl
                images(first: 1) {
                  edges {
                    node {
                      url
                      altText
                    }
                  }
                }
              }
            }
          }
        }`;

        theme.GraphQL.sendRequest(search_query,"available-in");
    }

    function buildOutput(response) {
        const current = this.$output_container.parent().data('current-product');
        let products = response.data.products.edges;

        products.map(product => {
            let title = product.node.title;
            let handle = product.node.handle;
            let image = product.node.images.edges[0].node.url;
            let url = product.node.onlineStoreUrl;

            let output = `
                <li>
                    <a href="/products/${handle}" data-tooltip="${title}" title="${title}" class="product-aa media-fit-cover${current == handle ? ' active' : ''}">
                        <img src="${image}" alt="${title}" loading="lazy" class="lazyload" />
                    </a>
                </li>
            `;

            this.$output_container.append(output)
        })
    }

    return {
        init: init,
        buildOutput: buildOutput
    }
})();


$(document).ready(function() {
    $('[data-custom-type="available-in"]').each(function() {
        theme.AlsoAvailableIn.init(this);
    });
});


// Product size on grid - add to cart
$(document).on('click', '.size-add-to-cart', (e) => {
    e.preventDefault();
    let variant_id =  e.target.getAttribute('data-variant-id');
    theme.Helpers.addItemToCartFromID(variant_id);
});

document.addEventListener('DOMContentLoaded', () => {
    const productGridSliders = document.querySelectorAll('product-grid-media [data-slider]');
    let flkty_arr = [];

    const initFlickityProductGrid = elem => {
        let flkty = new Flickity(elem, {
            prevNextButtons: true,
            pageDots: false,
            wrapAround: true,
            imagesLoaded: true,
            lazyLoad: 1
        })

        flkty_arr.push(flkty);
    }

    if (!document.querySelector('.interactive-size-guide')) {
        productGridSliders.forEach(initFlickityProductGrid);

        window.addEventListener('selectProductGridItemSlide', function(e) {
            const { slider: sliderIndex, index } = e.detail;
            flkty_arr[sliderIndex]?.select( index );
        }, false)
    }


    // Prevent anchor tag from being clicked on product grid image slideshows
    $(document).on('click', '.product-grid-slideshow .flickity-prev-next-button', (e) => {e.preventDefault()});
});